<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat>
        <v-toolbar-title>New Brand</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" small text to="/brands">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <!-- editor -->
        <editor :docCreate="docCreate" :initial="dataItem" @data="save"></editor>
        <!-- end -->
      </v-card-text>
    </v-card>

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
import Editor from "../_components/editor.vue";
export default {
  components: {
    Editor,
  },
  data: () => ({
    dataItem: {},
    docCreate: true
  }),
  methods: {
    save(data) {
      const url = "/brands";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.$router.push("/brands");
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
};
</script>